import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { AWS_AURORA_POSTGRES } from "../../Constants"

function ZdqAwsAuroraPostgresConnector() {
    return <ZdqConnectorSetup vendor={AWS_AURORA_POSTGRES}></ZdqConnectorSetup>
}

export default ZdqAwsAuroraPostgresConnector 